import React, { FC, useState } from 'react';
import { FormItemInjectedProps } from '~/types/FormItemInjectedProps';
import { KsaShareholders } from '~/types/ksa/KsaShareholders';
import LegalEntityEdit from '~/pages/ksa/application/shareholders/components/legalEntities/LegalEntityEdit';
import LegalEntitiesTable, {
  getLegalEntityData,
} from '~/pages/ksa/application/shareholders/components/legalEntities/LegalEntitiesTable';

const LegalEntitiesTableForm: FC<Partial<FormItemInjectedProps<KsaShareholders>>> = (props) => {
  const { value } = props as FormItemInjectedProps<KsaShareholders>;
  const shareholdersFormState = { shareholders: value };

  const [editUid, setEditUid] = useState('');
  const openEdit = (uid: string) => {
    setEditUid(uid);
  };
  const closeEdit = () => {
    setEditUid('');
  };

  const legalEntitiesDataSource = getLegalEntityData(shareholdersFormState, openEdit);

  return (
    <>
      {editUid && <LegalEntityEdit uid={editUid} onClose={closeEdit} {...props} />}
      <LegalEntitiesTable legalEntities={legalEntitiesDataSource} />
    </>
  );
};

export default LegalEntitiesTableForm;
